import { render } from "./VariantCell.vue?vue&type=template&id=f5fd0a9a&scoped=true"
import script from "./VariantCell.vue?vue&type=script&lang=js"
export * from "./VariantCell.vue?vue&type=script&lang=js"

import "./VariantCell.vue?vue&type=style&index=0&id=f5fd0a9a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5fd0a9a"]])

export default __exports__